import {
  SET_ACT_PROPERTY,
  REMOVE_IDENTITY,
  ACT_ERROR,
  UI_UPDATE_FROM_PARTNER,
  SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES,
  SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES,
  SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM,
  RESET_CHECK_TRANSFER_FILTERS,
  ACT_RESET_DATA_TO_SEND,
  ACT_RESET_TIRES
} from 'store/actions/act';
import { setValueObjectByField } from 'helpers/object';
import { STORE_ACT_NAMES } from 'store/enums';

export default {
  [SET_ACT_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [REMOVE_IDENTITY]: (state, { loginPartners }) => {
    state.dateCheck = new Date().toISOString();
    state.identityData = {
      idCliente: null,
      plate: null,
      idStoragePark: loginPartners ? state.identityData.idStoragePark : null
    };
  },

  [RESET_CHECK_TRANSFER_FILTERS]: (state, { loginPartners }) => {
    state.checkTransferFilters = {
      idStoragePark: loginPartners ? state.checkTransferFilters.idStoragePark : null,
      idProvider: null,
      dateCheck: new Date().toISOString(),
      idTransport: null,
      plate: null
    };
  },

  [ACT_ERROR]: (state, error) => {
    state.error = error;
  },

  [UI_UPDATE_FROM_PARTNER]: (state, { patternId, data }) => {
    const { risk } = data;
    state.risk[patternId] = risk;
  },

  /**
   *
   * @param {string} typeCheck - 'act' or 'transferAct'
   */
  [SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES]: (
    state,
    { typeCheck = STORE_ACT_NAMES.CLIENT_ACT, idAccesory, value, property }
  ) => {
    const { intAccesoriesCar } = state[typeCheck].variable;
    intAccesoriesCar.forEach(checklistItemValue => {
      if (checklistItemValue.idAccesory === idAccesory) {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue[property] = value;
      }
    });
  },

  /**
   *
   * @param {string} typeCheck - 'act' or 'transferAct'
   */
  [SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES]: (
    state,
    { typeCheck = STORE_ACT_NAMES.CLIENT_ACT, idAccesory, value, property }
  ) => {
    const { accesoriesCar } = state[typeCheck].variable;
    accesoriesCar.forEach(checklistItemValue => {
      if (checklistItemValue.idAccesory === idAccesory) {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue[property] = value;
      }
    });
  },

  /**
   *
   * @param {string} typeCheck - 'act' or 'transferAct'
   */
  [DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (
    state,
    { typeCheck = STORE_ACT_NAMES.CLIENT_ACT, code }
  ) => {
    const damagesCar = state[typeCheck].variable.damagesCar;
    const damageCar = damagesCar.find(el => el.codDamage === code);
    if (damageCar) {
      damageCar.isDamaged = false;
      state.checklistsExternalBreaks = state.checklistsExternalBreaks.filter(
        el => el.codDamage !== code
      );
    }
  },

  /**
   *
   * @param {string} typeCheck - 'act' or 'transferAct'
   */
  [SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (
    state,
    { typeCheck = STORE_ACT_NAMES.CLIENT_ACT, code }
  ) => {
    // const damagesCar = JSON.parse(JSON.stringify(state.act.variable.damagesCar));
    const damagesCar = state[typeCheck].variable.damagesCar;
    const damageCar = damagesCar.find(el => el.codDamage === code);
    if (damageCar) {
      damageCar.isDamaged = true;
      state.checklistsExternalBreaks.push(damageCar);
    }
  },

  [EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { code, data }) => {
    state.checklistsExternalBreaks = state.checklistsExternalBreaks.map(el => {
      if (el.codDamage !== code) return el;
      return {
        ...el,
        ...data
      };
    });
  },

  /**
   *
   * @param {string} typeCheck - 'act' or 'transferAct'
   */
  [SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM]: (
    state,
    { typeCheck = STORE_ACT_NAMES.CLIENT_ACT, id, value }
  ) => {
    const interiorDamage = state[typeCheck].variable.intDamagesCar;
    const interiorDamageItem = interiorDamage.find(el => el.codDamage === id);
    if (interiorDamageItem) {
      interiorDamageItem.isDamaged = value;
    }
  },

  [ACT_RESET_DATA_TO_SEND]: state => {
    state.checklistsExternalBreaks = [];
  },

  [ACT_RESET_TIRES]: (state, { field, value, storageAct, reset }) => {
    reset.forEach(fieldReset => {
      setValueObjectByField(state, `${storageAct}.variable.${fieldReset}`, null);
    });
    setValueObjectByField(state, field, value);
  }
};
